import PropTypes from "prop-types";
import { useState } from "react";

/*
 * Lookup panel. Submitting lifts the trimmed order ID to the page, which is
 * what the getOrderById query is keyed on — same single-field contract the
 * previous form had.
 */
const TrackForm = ({ initialValue, isLoading, onSubmit }) => {
  const [orderId, setOrderId] = useState(initialValue || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(orderId.trim());
  };

  return (
    <section className="c4trk__lookup" aria-labelledby="c4trk-lookup-heading">
      <h1 className="c4trk__lookup-title" id="c4trk-lookup-heading">
        Track Your Order
      </h1>
      <p className="c4trk__lookup-sub">
        Enter your order ID to get the latest updates on your shipment.
      </p>

      <form className="c4trk__form" onSubmit={handleSubmit} noValidate>
        <div className="c4trk__field">
          <label className="c4trk__label" htmlFor="c4trk-order-id">
            Order ID
          </label>
          <input
            className="c4trk__input"
            id="c4trk-order-id"
            name="orderid"
            type="text"
            autoComplete="off"
            placeholder="e.g. 65f2c1a9b4d3e07a1c8f4b21"
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            aria-describedby="c4trk-order-help"
            required
          />
        </div>

        <button
          className="c4trk__btn c4trk__btn--primary c4trk__submit"
          type="submit"
          disabled={isLoading || !orderId.trim()}
        >
          {isLoading ? "Tracking…" : "Track Order"}
        </button>
      </form>

      <p className="c4trk__help" id="c4trk-order-help">
        Your Order ID is on your order receipt and in your order confirmation
        email.
      </p>
    </section>
  );
};

TrackForm.propTypes = {
  initialValue: PropTypes.string,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default TrackForm;
